// src/store/dashboard.js
import { defineStore } from 'pinia';
import api from '../services/api';

export const useDashboardStore = defineStore('dashboard', {
    state: () => ({
        accounts: [],
        loading: true,
        error: null,
    }),
    actions: {
        async fetchAccounts() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.getAccounts();
                this.accounts = response.data;
            } catch (err) {
                this.error = 'Gagal memuat data rekening.';
                console.error("Fetch accounts failed:", err);
                // Biarkan komponen yang menangani logout jika terjadi 401
                if (err.response && err.response.status === 401) {
                    throw new Error('Unauthorized');
                }
            } finally {
                this.loading = false;
            }
        },
        // Aksi untuk membersihkan state saat pengguna logout
        clearDashboardState() {
            this.accounts = [];
            this.loading = true;
            this.error = null;
        }
    }
});